"use client";

import { useEffect } from "react";
import { useCurrentUser } from "@knowt/syncing/hooks/user/useCurrentUser";
import { SubscriptionType } from "@knowt/syncing/graphql/schema";
import { useLayup } from "@layuplabs/react";

const SyncLayupData = () => {
    const { user, userId, isLoading } = useCurrentUser({ waitForFallbackData: true, from: "SyncLayupData" });
    const { initLayup, isInitialized } = useLayup();

    useEffect(() => {
        if (!userId || !user || isLoading || isInitialized) return;

        const loadLayup = async () => {
            const theme = document.documentElement.getAttribute("data-theme");

            try {
                initLayup({
                    group_id: "everyone",
                    user_data: {
                        email: user.Email,
                        first_name: user.Name ?? "",
                        user_id: user.ID ?? "",
                        username: user.username ?? "",
                        plan_identifier: user?.subscriptionType ?? SubscriptionType.BASIC,
                        role_identifier: user?.accountType,
                    },
                    theme: { mode: theme === "dark" ? "dark" : "light" },
                    anchor: {
                        id: "layup-get-started",
                        side: "right",
                        align: "bottom",
                        sideOffset: 20,
                        alignOffset: 10,
                    },
                });
            } catch (error) {
                // biome-ignore lint: use console.error
                console.error("Failed to initialize Layup:", error);
            }
        };

        loadLayup();
    }, [userId, isLoading]);

    return null;
};

export default SyncLayupData;
